/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @private
 * @typedef {Pick<import('../content-task').ContentTask, 'id' | 'priority'>} IContentTask
 */

/**
 * Porovnávač obsahových úloh.
 *
 * Určuje priority, jaké mají obsahové úlohy mít.
 * Pokud se má přehrávat více úloh zároveň, rozhodne která má přednost.
 *
 * Porovnává se na základě následujících priorit (od nevyšší):
 * 1. {@link ContentTask#priority}
 * 2. {@link ContentTask#id}
 */
class ContentTaskComparator {
  /**
   * Porovná dvě obsahové úlohy.
   * @param {IContentTask} a První úloha
   * @param {IContentTask} b Druhá úloha
   * @returns {number} Číslo dle `compareFunction` v `Array.sort`:
   * - n < 0: První úloha má nižší prioritu než druhá.
   * - n === 0: Obě úlohy mají stejnou prioritu.
   * - n > 1: První úloha má vyšší prioritu než druhá.
   */
  static compare(a, b) {
    return a.priority - b.priority || a.id - b.id;
  }
}

export default ContentTaskComparator;
